import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { useContent } from "../../../../context/ContentContext";

const StatusDialog = () => {
    const { userStatus } = useContent(); // Get user status from context
    const [open, setOpen] = useState(false); // Manage dialog visibility
    const navigate = useNavigate();

    useEffect(() => {
        // Open the dialog for specific user statuses
        if (userStatus === 0 || userStatus === 1 || userStatus === 3) {
            setOpen(true);
        } else if (userStatus === 2) {
            setOpen(false); // Close the dialog when the status becomes active
        }
    }, [userStatus]);

    const handleClose = () => {
        // Prevent closing unless userStatus is 2
        if (userStatus === 2) {
            setOpen(false);
        }
    };

    const handleRouteToProfile = () => {
        navigate("/profile");
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose} // Disable closing for statuses other than 2
            disableEscapeKeyDown={userStatus !== 2} // Disable escape key unless userStatus is 2
        >
            <DialogTitle>
                {userStatus === 0
                    ? "Akun Tidak Aktif"
                    : userStatus === 1
                        ? "Akun Menunggu Persetujuan"
                        : userStatus === 3
                            ? "Akun Diblokir"
                            : ""}
            </DialogTitle>
            <DialogContent>
                {userStatus === 0 && (
                    <p>Akun Anda tidak aktif. Silakan perbarui informasi profil Anda untuk mengaktifkan akun.</p>
                )}
                {userStatus === 1 && (
                    <p>Akun Anda sedang menunggu persetujuan. Harap tunggu 1x24 jam atau hubungi recruiter Anda.</p>
                )}
                {userStatus === 3 && (
                    <p>
                        Akun Anda telah diblokir. Silakan hubungi admin untuk informasi lebih lanjut. Dialog ini tidak
                        dapat ditutup.
                    </p>
                )}
            </DialogContent>
            {userStatus === 0 && (
                <DialogActions>
                    <Button onClick={handleRouteToProfile} color="primary">
                        Perbarui Profil
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default StatusDialog;
